<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';
import { RouterView } from 'vue-router';
import { ModalsContainer } from 'vue-final-modal';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const user = ref(null);
const auth = getAuth();

onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    user.value = currentUser;
  });
});
</script>

<template>
  <div class="app-container">
    <Nav v-if="user" />
    <main class="page-content">
      <RouterView />
    </main>
    <ModalsContainer />
    <Footer />
  </div>
</template>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
